import { createContext, useContext, useEffect, useState } from "react";
import { adminApi } from "./api";

const AuthCtx = createContext(null);
export const useAdminAuth = () => useContext(AuthCtx);

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null=checking, false=unauth, obj=auth
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("sr_admin_token");
    if (!token) {
      setAdmin(false);
      setReady(true);
      return;
    }
    adminApi
      .get("/me")
      .then((r) => setAdmin(r.data))
      .catch(() => {
        localStorage.removeItem("sr_admin_token");
        setAdmin(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/login", { email, password });
    if (data.requires_2fa) return data; // challenge step — no token yet
    localStorage.setItem("sr_admin_token", data.token);
    setAdmin(data.user);
    return data.user;
  };

  const verify2fa = async (txnId, code, trustDevice) => {
    const { data } = await adminApi.post("/login/2fa", { txn_id: txnId, code, trust_device: trustDevice });
    localStorage.setItem("sr_admin_token", data.token);
    setAdmin(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("sr_admin_token");
    setAdmin(false);
    window.location.href = "/admin/login";
  };

  const hasPerm = (perm) => {
    if (!admin) return false;
    if (admin.role === "super_admin") return true;
    const perms = admin.permissions || [];
    return perms.includes("Full system access") || perms.includes(perm);
  };

  return <AuthCtx.Provider value={{ admin, ready, login, verify2fa, logout, hasPerm }}>{children}</AuthCtx.Provider>;
};
